import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPayrollOtherDetailsHistory = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PayrollOtherDetailsHistory/get`, {
      Payroll_Id: filter.Payroll_Id || null,
      Employee_Id: filter.Employee_Id || null
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollOtherDetailsHistoryAPI] Failed to fetch payroll other details history:", error);
    throw error;
  }
}; 